import React from 'react';

import { STATIC_ROOT } from '../../../../constants';

import SvgComponent from '../../../SvgComponent';

import { CardsPictoWrapper } from './CardsPictoStyle';

const CardsPicto = () => {
    return (
        <CardsPictoWrapper>
            <SvgComponent src={`${STATIC_ROOT}/payment/visa.svg`} height={25} />
            <SvgComponent src={`${STATIC_ROOT}/payment/mastercard.svg`} height={25} />
            <SvgComponent src={`${STATIC_ROOT}/payment/cb2.svg`} height={25} />
        </CardsPictoWrapper>
    );
};

export default CardsPicto;



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/CardsPicto.js